import { UserResource } from "@clerk/types";
const isAdmin = (user: UserResource | null | undefined) => {
  if (!user) return false;
  const rolesArray: string[] = user.publicMetadata?.roles as string[];
  if (rolesArray?.length > 0) {
    return rolesArray.includes("Administrator");
  }
};

const isSuperAdmin = (user: UserResource | null | undefined) => {
  if (!user) return false;
  const rolesArray: string[] = user.publicMetadata?.roles as string[];
  if (rolesArray?.length > 0) {
    return rolesArray.includes("SuperAdmin");
  }
};

export { isAdmin, isSuperAdmin };
